/**
 * 学习乐园 · 排排序题材包：八大行星距日（paixu/pack-xingxing.js）
 * ---------------------------------------------------------------------------
 * 八大行星按离太阳从近到远排（水金地火木土天海）。note 讲一个辨认特征
 * ——排一遍记住的不只是顺序，还有每颗星「凭什么认出它」。
 * 口径：2006 年国际天文学联合会把冥王星划为矮行星，行星就八个——
 * 排序里没有它，doc 页和通关语都会说明，不悄悄改口径。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  PACKS.xingxing = {
    id: 'xingxing',
    name: '行星距日',
    hint: '八大行星从近到远排',
    cols: 4,
    winText: '水金地火木土天海——2006 年起冥王星是矮行星，行星就这八个。',
    items: [
      { face: '水星', note: '离太阳最近，88 天就绕一圈' },
      { face: '金星', note: '夜空中最亮的行星，又叫启明星' },
      { face: '地球', note: '我们的家，唯一已知有生命' },
      { face: '火星', note: '红色星球，有太阳系最高的山' },
      { face: '木星', note: '最大的行星，大红斑刮了三百多年' },
      { face: '土星', note: '光环最壮观' },
      { face: '天王星', note: '「躺着」自转的冰巨星' },
      { face: '海王星', note: '离太阳最远，风速最快' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
